import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { deliverables, product } from '../data/landing';
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-6 bg-paper py-16 lg:py-24" aria-labelledby="oferta-titulo" data-id="element-141" data-mp="1mo20u1famner">
      <div className="mx-auto max-w-3xl px-6" data-id="element-142" data-mp="1hoxv5krkv7t6">
        <div className="rounded-3xl bg-cream p-8 ring-1 ring-teal/15 sm:p-12" data-id="element-143" data-mp="tyldvjafzypx">
          <h2 id="oferta-titulo" className="font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-144" data-mp="u0ocustkp26s">
            Recupere su libertad de movimiento hoy mismo
          </h2>
          <p className="mt-5 font-sans text-xl leading-relaxed text-inkSoft" data-id="element-145" data-mp="yy7orm2st2vk">
            El acceso completo a {product.title} está disponible por un pago
            único. No es una suscripción, es su manual de vida.
          </p>

          <ul className="mt-8 space-y-3 border-y border-teal/15 py-8" data-id="element-146" data-mp="2acbj4tdast15">
            {deliverables.map(item => <li key={item.name} className="flex items-start gap-3" data-id="element-147" data-mp="pjp8ru1dymmr">
                <CheckIcon className="mt-1 h-5 w-5 flex-none text-teal" aria-hidden="true" data-id="element-148" data-mp="uiin1oohyhnz" />
                <span className="font-sans text-lg text-ink sm:text-xl" data-id="element-149" data-mp="zgafcjt205sp">
                  {item.name}
                </span>
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-150" data-mp="6v0w1vd23nm2">
            <p className="font-sans text-base font-semibold uppercase tracking-wide text-clay" data-id="element-151" data-mp="6rwiw8hm5hj9">
              Precio especial de lanzamiento
            </p>
            <div className="mt-3 flex flex-wrap items-end gap-x-4 gap-y-2" data-id="element-152" data-mp="ftm8r9vuk8ex">
              <span className="font-sans text-2xl text-inkSoft line-through decoration-clay decoration-2" data-id="element-153" data-mp="kle0vounim76">
                {product.originalPrice}
              </span>
              <p className="flex items-baseline gap-3" data-id="element-154" data-mp="3k6t1bywmoj42">
                <span className="font-serif text-6xl font-semibold leading-none text-ink" data-id="element-155" data-mp="3o8wgaxiia5u3">
                  {product.price}
                </span>
                <span className="font-sans text-xl text-inkSoft" data-id="element-156" data-mp="qgnpoazkcuh2">
                  {product.currency} · pago único
                </span>
              </p>
            </div>
            <p className="mt-3 inline-flex rounded-lg bg-clay-soft px-3 py-1.5 font-sans text-base font-semibold text-clay-dark" data-id="element-157" data-mp="157mvxfcxf6xh">
              Ahorra $20.61 hoy (76% de descuento)
            </p>
          </div>

          <CtaButton variant="checkout" className="mt-8 w-full" data-id="element-158" data-mp="cipok7a96uji" />

          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 font-sans text-base text-inkSoft" data-id="element-159" data-mp="7jcr6slra52o">
            <span className="inline-flex items-center gap-2" data-id="element-160" data-mp="liw19qy4nqhm">
              <ZapIcon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-161" data-mp="hfptgevd9r91" />
              Acceso inmediato tras la compra
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-162" data-mp="1wuwupj5xs33p">
              <LockIcon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-163" data-mp="1su34gj50uc7n" />
              Pago seguro y cifrado
            </span>
          </div>
        </div>
      </div>
    </section>;
}